import React, { useContext, useEffect, useState } from 'react'
import { Container } from 'react-bootstrap';
import Body from '../../components/Body/Body';
import { CartContext } from "../../context/CartContext";
import { Dropdown, Menu, Button, Modal, Pagination } from "antd";
import { DownOutlined } from "@ant-design/icons";
import './Product.css'
import listApi from '../../services/api';
import { AuthContext } from '../../context/AuthContext';
const noImg = 'https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg'
  const url_img = 'https://matmasocaivan.com/MMS_data/'
export const Product = () => {
  // const products = data.products.data.items;
  const { userData } = useContext(AuthContext);
  const { addToCart } = useContext(CartContext);
  const [category, setCategory] = useState("all");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [products, setProducts] = useState();
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(false)

  const pageSize = 30; // Số sản phẩm mỗi trang

  // Lọc sản phẩm theo trang
  const indexOfLastProduct = currentPage * pageSize;
  const indexOfFirstProduct = indexOfLastProduct - pageSize;
  // const currentProducts = products.slice(indexOfFirstProduct, indexOfLastProduct);

  // Danh sách danh mục sản phẩm
  const categories = [
    { value: "all", label: "Tất cả sản phẩm" },
    { value: "books", label: "Sách" },
    { value: "courses", label: "Khoá học" },
    { value: "jewelry", label: "SP phong thuỷ - Trang sức" },
    { value: "fengshui", label: "Vật phẩm phong thuỷ" }
  ];


  useEffect(() => {
    fetchProducts();
    console.log(userData.session_id)
  }, [])


  // Xử lý chọn danh mục
  const handleMenuClick = (e) => {
    setCategory(e.key);
  };

  // Tạo menu dropdown
  const menu = (
    <Menu onClick={handleMenuClick}>
      {categories.map((cat) => (
        <Menu.Item key={cat.value}>{cat.label}</Menu.Item>
      ))}
    </Menu>
  );


  // Lọc sản phẩm theo danh mục
  // const filteredProducts = category === "all"
  //   ? products
  //   : products.filter(product => product.category === category);


  const showModal = (product) => {
    setSelectedProduct(product);
    setIsModalVisible(true);
  };

  // Đóng Modal
  const handleClose = () => {
    setIsModalVisible(false);
    setSelectedProduct(null);
  };

  const fetchProducts = async () => {
    setLoading(true)
    try {
      const response = await fetch(listApi.listAllProduct, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: userData.session_id }),
      });
      const data = await response.json();

      console.log("Dữ liệu API trả về:", data); // Debug để kiểm tra dữ liệu

      if (data.code === 200 && Array.isArray(data.list_product)) {
        setLoading(false)
        setProducts(data.list_product);
        setFilteredProducts(data.list_product);
      } else {
        setLoading(false)
        console.error("Dữ liệu trả về không hợp lệ:", data.list_product);
        setFilteredProducts([]); // Tránh lỗi khi gọi `.slice()`
      }
    } catch (error) {
      setLoading(false)
      console.error("Lỗi khi lấy dữ liệu sản phẩm:", error);
      setFilteredProducts([]); // Đảm bảo không bị undefined
    }
  };


  return (
    <Container>
      <Body>
        <div className="product-container">
          <h1>Danh sách sản phẩm</h1>
          <div className="filter-container">
            <h4>Lọc sản phẩm: </h4>
            <Dropdown overlay={menu} trigger={['click']}>
              <Button>
                {categories.find(cat => cat.value === category)?.label} <DownOutlined />
              </Button>
            </Dropdown>
          </div>
          <div className="product-list">
            {Array.isArray(filteredProducts) && filteredProducts.length > 0 ? (
              filteredProducts.slice((currentPage - 1) * pageSize, currentPage * pageSize).map((product) => (

                <div className="product-card" key={product.ID} onClick={() => showModal(product)}>
                  <img src={product.picture_url  ?  (url_img +product.picture_url) : noImg } alt={product.product_name} />
                  <h3 className="product-title">{product.product_name}</h3>
                  <p className="number">Số lượng: {product.number}</p>
                  <p className="price">Giá: {product.price.toLocaleString()}đ</p>
                </div>
              ))
            ) : (
              <p className="no-products">⚠️ Danh mục hiện tại không có sản phẩm nào.</p>
            )}
          </div>
          {/* Modal hiển thị chi tiết sản phẩm */}
          <Modal title="Chi tiết sản phẩm" open={isModalVisible} onCancel={handleClose} footer={null}>
            {selectedProduct && (
              <div className="product-detail">
                <img src={selectedProduct.picture_url ? (url_img + selectedProduct.picture_url) : noImg} alt={selectedProduct.product_name} style={{ width: "100%" }} />
                <h2>{selectedProduct.product_name}</h2>
                <p><strong>Mô tả:</strong> {selectedProduct.product_info}</p>
                <p><strong>Mã sản phẩm:</strong> {selectedProduct.product_code}</p>
                <p><strong>Loại sản phẩm:</strong> {selectedProduct.product_type}</p>
                <p><strong>Số lượng:</strong> {selectedProduct.number}</p>
                <p className="price"><strong>Giá:</strong> {selectedProduct.price.toLocaleString()}đ</p>
                <button className="add-to-cart" onClick={() => addToCart({ ...selectedProduct, quantity: 1 })}>
                  Thêm vào giỏ hàng
                </button>
              </div>
            )}
          </Modal>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={filteredProducts.length}
            onChange={(page) => setCurrentPage(page)}
            showSizeChanger={false}
          />
        </div>
      </Body>
    </Container>
  )
}

export default Product;
